var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('router-view',{attrs:{"id":"content-wrap"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }